import { LINE_SLOT_ATTR } from '@root/helpers/editor';
import type { Attribute } from '@tiptap/core';

export const lineSlot = {
  default: null,
  parseHTML: (element: HTMLElement) => {
    const value = element.getAttribute(LINE_SLOT_ATTR);
    const points = Number(value);
    return value && Number.isFinite(points) && points >= 0 ? points : null;
  },
  renderHTML: ({ lineSlot: points = null }: { lineSlot?: number | null }) =>
    points === null ? {} : { [LINE_SLOT_ATTR]: points, style: `--line-slot: ${points}` },
} satisfies Attribute;
